import type { Logger } from "~/tools/logger";
import { EMPTY, type Observable } from "~/tools/rxjs";

function getErrorMessage(error: unknown, unknownErrorTypeHandler: (error: unknown) => string): string {
	if (error instanceof Error) {
		return error.message;
	}

	if (typeof error === "string") {
		return error;
	}

	return unknownErrorTypeHandler(error);
}

/**
 * @deprecated avoid using anything related to rxjs
 */
export function createEpicErrorHandler(logger: Logger): (error: unknown) => Observable<never> {
	return (error) => {
		logger.error(getErrorMessage(error, JSON.stringify));

		return EMPTY;
	};
}
